export interface PaymentProviderIntegration {
  initiateSession: (cartId: string, version: number) => Promise<PaymentMethodsData>;
  endSession: () => void;
  createPaymentWidget: (params: CreatePaymentWidgetParams) => Promise<MountableElement>;
  makePaymentRequest: (
    paymentId: string,
    paymentMethodType: PAYMENT_METHODS,
    isSubscription: boolean
  ) => Promise<PaymentResult | null>;
  cancelPayment: <Order>(orderId: string, lineItemId: string) => Promise<Order | null>
}

export interface CreatePaymentWidgetParams {
  paymentMethodType: PAYMENT_METHODS;
  onChange?: (isValid: boolean) => void;
  amount?: {
    value: number;
    currency: string;
  };
  onSubmit?: (resultCode: string, refusalReason?: string) => Promise<void>;
  isSubscription?: boolean;
}

export enum PAYMENT_METHODS {
  PayPal = 'paypal',
  Card = 'card',
  SavedCard = 'saved-card'
}

export interface StoredPaymentMethodData {
  name: string;
  lastFour: string;
  expiryMonth: string;
  expiryYear: string;
}

export interface PaymentMethodsData {
  paymentId: string;
  availablePaymentMethods: string[];
  storedPaymentMethods: StoredPaymentMethodData[];
}

export interface PaymentResult {
  resultCode: string;
  refusalReason?: string;
}

export interface MountableElement {
  mount: (parent: HTMLElement) => void;
}
